import React from 'react';
import {
  useDataModel, extend, params, shape, string, arrayOf
} from '@thd-nucleus/data-sources';
import { string as stringType } from 'prop-types';

import {
  FormController,
  Link,
  Typography,
  Dropdown,
  MenuItem,
  SkeletonLine
} from '@one-thd/sui-atomic-components';

const StoreHeroDropdown = ({ storeZip }) => {
  const { data, loading } = useDataModel('storeServices', { variables: { zipCode: storeZip } });
  const services = data?.storeServices?.storeServices || [];

  if (loading) {
    return (
      <div className="sui-mt-2" data-component="StoreHeroDropdownPlaceholder">
        <SkeletonLine variant="single" style={{ height: '40px', width: '100%' }} />
      </div>
    );
  }

  const sanatizedList = [];
  services.forEach((service) => {
    sanatizedList.push({ name: service?.name, leadPageUrl: '' });
    service.storeServiceSubCategories.forEach((subItem) => {
      sanatizedList.push({
        name: subItem?.name,
        leadPageUrl: subItem?.leadPageUrl
      });
    });
  });

  return (
    <>
      {sanatizedList.length !== 0
    && (
      <div className="sui-mt-2" data-component="StoreHeroDropdown">
        <FormController fullWidth>
          <Dropdown
            placeholder="Let us help you with..."
            id="home-services-dropdown"
            defaultValue={null}
          >
            {
            sanatizedList?.map((item, index) => (
              <MenuItem key={`dropdown-service-item-${index}`} value={item?.name}>
                {item?.leadPageUrl
                  ? (
                    <Link
                      underline="none"
                      variant="body-lg"
                      className="sui-w-full"
                      href={item?.leadPageUrl}
                    >
                      {item?.name}
                    </Link>
                  )
                  : <Typography variant="body-xs">{item?.name}</Typography>}
              </MenuItem>
            ))
            }
          </Dropdown>
        </FormController>
      </div>
    )}
    </>
  );
};

StoreHeroDropdown.propTypes = {
  storeZip: stringType
};

StoreHeroDropdown.defaultProps = {
  storeZip: '30339'
};

StoreHeroDropdown.dataModel = extend({
  storeServices: params({ zipCode: string().isRequired() }).shape({
    storeServices: arrayOf(shape({
      name: string(),
      namespace: string(),
      imageUrl: string(),
      storeServiceSubCategories: arrayOf(shape({
        name: string(),
        rank: string(),
        leadPageUrl: string()
      })),
    })),
  }),
});

export { StoreHeroDropdown };
